import { render } from "./ArtworkCompletedTable.vue?vue&type=template&id=2be9f1d3&scoped=true"
import script from "./ArtworkCompletedTable.vue?vue&type=script&lang=js"
export * from "./ArtworkCompletedTable.vue?vue&type=script&lang=js"

import "./ArtworkCompletedTable.vue?vue&type=style&index=0&id=2be9f1d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be9f1d3"]])

export default __exports__